import React from 'react';
import { FadeIn } from './FadeIn';
export function BonusSection() {
  const bonuses = [{
    title: '100 Citas en Familia',
    value: '$12.000'
  }, {
    title: '100 Citas Padre e Hija',
    value: '$10.000'
  }, {
    title: '100 Citas Juntos (Pareja)',
    value: '$15.000'
  }, {
    title: '25 Citas con mis Peluditos (Mascotas)',
    value: '$5.000'
  }];
  return <section className="py-10 bg-slate-900 text-white relative overflow-hidden" data-id="element-12" data-mp="1ap8ptlpfdw0h">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-brand-500/10 rounded-full blur-3xl" data-id="element-13" data-mp="15r7751vwvypj"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-brand-500/10 rounded-full blur-3xl" data-id="element-14" data-mp="1ji27tqw9b9i1"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-15" data-mp="1eorb4il5s93u">
        <FadeIn data-id="element-16" data-mp="qzolooka9bys">
          <div className="text-center max-w-3xl mx-auto mb-8" data-id="element-17" data-mp="qz59zpl87jt7">
            <div className="inline-block bg-brand-500 text-white font-bold px-4 py-1 rounded-full text-sm mb-3 animate-pulse" data-id="element-18" data-mp="mzecz453w7g8">
              SOLO POR HOY
            </div>
            <h2 className="text-2xl md:text-4xl font-bold mb-3" data-id="element-19" data-mp="29q8pqnjcl3i6">
              BONOS EXCLUSIVOS
            </h2>
            <p className="text-lg text-slate-300" data-id="element-20" data-mp="2jhwgem82ygil">
              Llevate todo este contenido adicional completamente gratis con tu
              compra de hoy.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto" data-id="element-21" data-mp="1qth2y44lk69d">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-22" data-mp="1vtd3fte35fk6" data-mpi={index}>
              <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 p-6 rounded-2xl flex items-center gap-4 hover:bg-slate-800 transition-colors" data-id="element-23" data-mp="20rem4d7lncv4">
                <div className="text-4xl bg-slate-700 w-16 h-16 rounded-xl flex items-center justify-center shrink-0" data-id="element-24" data-mp="25rsww30l50wu">
                  🎁
                </div>
                <div data-id="element-25" data-mp="3h4ven1ef7wil">
                  <h3 className="font-bold text-lg md:text-xl mb-1" data-id="element-26" data-mp="3h4bsf8hqmlyr">
                    {bonus.title}
                  </h3>
                  <div className="flex items-center gap-2 text-sm md:text-base" data-id="element-27" data-mp="1h5hzgt81e2jv">
                    <span className="text-slate-400 line-through" data-id="element-28" data-mp="1c3slp5tfjas3">
                      Valorado en {bonus.value}
                    </span>
                    <span className="text-brand-400 font-bold" data-id="element-29" data-mp="1m2rmk27ye24j">→ ¡GRATIS!</span>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}